import { Inject, Options, Prop, Vue, Watch } from "vue-property-decorator";
import { TrustAPI } from "@/shared/modules/trust-api";
import { AppInsights } from "@/trust-atcs-app/appInsights";
import store from "@/trust-atcs-app/store";
import { EventEmitter } from "events";

export default class FirmSelector extends Vue {

    @Prop({ default: false })
    private practices!: boolean;
    private selectedPractice: any = null;
    private errorProceed = false;

    private setSelectedPractice(practice: any): void {
        this.selectedPractice = practice;
    }

    private emitSetSelectFirm(): void {
        if (!this.selectedPractice) {
            this.errorProceed = true;
            return;
        } else {
            this.errorProceed = false;
            this.$emit('selectedPractice', this.selectedPractice);
        }
    }
}